import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfigurationService } from '../../../configuration/app-configuration.service';
import { DictionaryServiceBase } from '../common/dictionary-service-base';
import { DictionaryType } from '../../dictionary-type.enum';
import { DictionaryMode } from '../../dictionary-mode.enum';
import { ICultivationDictionaryModel } from './cultivation-dictionary.model';

@Injectable()
export class CultivationInterCropDictionaryService extends DictionaryServiceBase<ICultivationDictionaryModel[]> {
  constructor(
    private httpClient: HttpClient,
    private config: AppConfigurationService
  ) {
    super();
  }

  type: DictionaryType = DictionaryType.CultivationInterCrop;
  mode: DictionaryMode = DictionaryMode.Static;

  loadData(): Observable<ICultivationDictionaryModel[]> {
    const url = `${this.config.configuration.api_url}/definitions/cultivations`;
    return this.httpClient.get<ICultivationDictionaryModel[]>(url).pipe(map(res => res.filter(x => x.isIntercrop)));
  }
}
